import React from 'react';
import { graphql } from 'gatsby';
import Head from '../components/Head';
import WorkspaceSelection from '../components/WorkspaceGrid/WorkspaceSelection';
import WorkspaceSubCatBreadcrumb from '../components/WorkspaceGrid/WorkspaceSubCatBreadcrumb';

export default function WorkspaceSubCategories({ data: { workspaceCategory }, location, path }) {
  let heading = workspaceCategory.heading;
  let description = workspaceCategory.description?.description;
  let [categoryImage] = workspaceCategory.images || [];
  let image = categoryImage?.image?.file?.url;

  return (
    <>
      <Head location={location} title={heading} description={description} image={image} />
      <WorkspaceSelection
        heading={workspaceCategory.heading}
        description={workspaceCategory.body?.body}
        workspaceSubcategories={workspaceCategory.workspaceSubCategories}
      />
      <WorkspaceSubCatBreadcrumb
        subCategories={workspaceCategory.workspaceSubCategories}
        workspaceSubCatHeading={workspaceCategory.heading}
        workspaceSubCatLink={path}
      />
    </>
  );
}

export const query = graphql`
  query($id: String!) {
    workspaceCategory: contentfulWorkspaceCategory(id: { eq: $id }) {
      id
      heading
      slug
      numberOfSeats
      body {
        body
      }
      description {
        description
      }
      images {
        image {
          file {
            url
          }
        }
      }
      gridSize
      workspaceSubCategories {
        ...WorkspaceSelectionSubcategory
      }
    }
  }
`;
